// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__p1Umw","img":"Spinner_img__1AAYy","Spin":"Spinner_Spin__1LhOx","text":"Spinner_text__3mUTD","FadeInOut":"Spinner_FadeInOut__1EySF"};